export enum ApplicationType {
  NewApplication = 'NewApplication',
  UpdateApplication = 'UpdateApplication',
  CancelApplication = 'CancelApplication',
  CancelContract = 'CancelContract',
  Leave = 'Leave'
}

export const getApplicationText = (value: ApplicationType) => {
  switch (value) {
    case ApplicationType.NewApplication:
      return '新規';
    case ApplicationType.UpdateApplication:
      return '変更';
    case ApplicationType.CancelContract:
      return '解約';
    case ApplicationType.CancelApplication:
      return 'キャンセル';
    case ApplicationType.Leave:
      return '退居';
  }
};
